import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

interface PepRawJsonDialogData {
  report: any;
}

@Component({
  selector: 'itfg-pep-raw-json-dialog',
  templateUrl: './pep-raw-json-dialog.component.html',
  styleUrls: ['./pep-raw-json-dialog.component.scss'],
  standalone: false,
})
export class PepRawJsonDialogComponent {
  readonly jsonString: string;
  readonly shouldShowNoRecords: boolean;
  readonly noRecordsText: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PepRawJsonDialogData,
    private translate: TranslateService
  ) {
    const report = data?.report;
    const hasRecords =
      Array.isArray(report?.data?.records) && report.data.records.length > 0;
    this.shouldShowNoRecords = report == null || !hasRecords;
    this.noRecordsText = this.translate.instant('riskIndicators.noRecords');
    this.jsonString = JSON.stringify(report, null, 2);
  }

  copyJson(): void {
    const textToCopy = this.jsonString ?? '';
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(textToCopy).catch(() => {
        this.fallbackCopy(textToCopy);
      });
      return;
    }

    this.fallbackCopy(textToCopy);
  }

  private fallbackCopy(text: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', 'true');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }
}
